var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { FormattedNumber, injectIntl } from "react-intl";
import { ApplicationContext } from "../../../ApplicationContext";
import ActivityStatus from '../../../data/ActivityStatus';
import Signals from '../../../signals/Signals';
import Label from '../../components/ui/Label/Label';
import { SystemFeatureToggle } from "../../../data/SystemFeatureToggle";
import Session from "../../../services/Session";
import DateTime from "../../components/ui/DateTime/DateTime";
import { AssetDetailTabs } from "./AssetDetail";
import ServiceEntryStatus from "../../../data/ServiceEntryStatus";
import Feature from "../../components/ui/Feature/Feature";
import "external-svg-loader";
import AssetIcon from './AssetIcon';
import DeviceBatteryStatus from '../../components/ui/DeviceBatteryStatus/DeviceBatteryStatus';
/**
 *
 */
var AssetTableRow = /** @class */ (function (_super) {
    __extends(AssetTableRow, _super);
    /**
     *
     */
    function AssetTableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    /**
     *
     * @returns {*}
     */
    AssetTableRow.prototype.render = function () {
        var _this = this;
        var _a = this.props, assetModel = _a.assetModel, isArchived = _a.isArchived, compact = _a.compact;
        var applicationModel = this.context.applicationModel;
        var properties = assetModel.properties;
        var fuelUsedDate = new Date(assetModel.fuelUsedDateTime);
        var cumulativeOperatingHoursDate = assetModel.cumulativeOperatingHoursDateTime;
        var user = Session.user;
        var newServiceEntries = assetModel.serviceEntries.filter(function (serviceEntryModel) { return serviceEntryModel.calculatedStatus === ServiceEntryStatus.Created; });
        var inProgressServiceEntries = assetModel.serviceEntries.filter(function (serviceEntryModel) { return serviceEntryModel.calculatedStatus === ServiceEntryStatus.InProgress; });
        var classes = classNames({
            'bg-white': true,
            'row': true,
            'ml-4': true,
            'mr-4': true,
            'mb-4': !compact,
            'mb-2': compact,
            'pt-4': !compact,
            'pb-4': !compact,
            'pt-2': compact,
            'pb-2': compact,
            'pr-2': true,
            'asset-table-row': true,
            'asset-table-row--selected': applicationModel ? applicationModel.selectedAsset === assetModel : false
        });
        return (React.createElement("div", { style: { display: "contents" }, onClick: function () { return _this.showAssetDetail(); }, className: classes },
            React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                React.createElement("div", { className: 'text-nowrap pt-0' }, properties.iconName &&
                    React.createElement(AssetIcon, { height: compact ? "2lh" : "3lh", assetModel: assetModel }))),
            React.createElement("div", { className: 'text-uppercase font-weight-bold text-nowrap' }, properties.displayedId),
            React.createElement("div", { className: "text-uppercase text-nowrap" }, properties.make),
            React.createElement("div", { className: 'text-uppercase text-nowrap' }, properties.model),
            React.createElement("div", { className: 'text-uppercase' }, properties.serialNumber),
            React.createElement("div", { className: "text-uppercase" + (compact ? 'text-nowrap' : null) }, assetModel.labels.map(function (labelModel, index) {
                return React.createElement(Label, { key: index + '-' + labelModel.id, model: labelModel, compact: compact });
            })),
            React.createElement(Feature, { hasAny: [SystemFeatureToggle.SERVICEFEATUREPACK] },
                React.createElement("div", { className: 'text-center ' + (compact ? 'text-nowrap' : null), onClick: function (event) {
                        if (newServiceEntries.length > 0) {
                            event.stopPropagation();
                            Signals.HideOverlay.dispatch();
                            Signals.ShowAssetDetail.dispatch(assetModel, AssetDetailTabs.ASSET_SERVICE_ENTRIES);
                        }
                    } },
                    newServiceEntries.length > 0 ?
                        React.createElement("span", { className: "asset-service-entry-notification badge badge-pill badge-success mx-1" }, newServiceEntries.length) : null,
                    inProgressServiceEntries.length > 0 ?
                        React.createElement("span", { className: "asset-service-entry-notification badge badge-pill badge-warning mx-1" }, inProgressServiceEntries.length) : null)),
            React.createElement("div", null, assetModel.devices.map(function (device, index) {
                return React.createElement(DeviceBatteryStatus, { key: index + '-' + device.link_device_id, device: device, compact: compact });
            })),
            !isArchived &&
                React.createElement("div", null,
                    assetModel.hasOperatingHours ?
                        React.createElement(FormattedNumber, { value: properties.cumulativeOperatingHoursDurationInHours, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 }) : '-',
                    !compact && assetModel.hasOperatingHours && properties.cumulativeOperatingHoursDateTimeUtc ?
                        (React.createElement("span", { className: "small text-muted d-block d-flex" },
                            React.createElement(DateTime, { date: cumulativeOperatingHoursDate }))) : null),
            !isArchived &&
                React.createElement("div", { className: "pr-4 text-nowrap" },
                    assetModel.hasLocation ?
                        React.createElement("a", { href: assetModel.googleMapsUrl, target: "_blank" },
                            React.createElement("div", { className: "d-flex justify-content-between w-100" },
                                assetModel.place,
                                React.createElement("i", { className: "ml-4 fe fe-external-link" }))) : '-',
                    !compact && assetModel.hasLocation &&
                        React.createElement("span", { className: "small text-muted d-flex" },
                            React.createElement(DateTime, { date: assetModel.locationDateTime, timeClasses: this.getLocationTimeClasses() })))));
    };
    /**
     *
     */
    AssetTableRow.prototype.showAssetDetail = function () {
        var assetModel = this.props.assetModel;
        Signals.ShowAssetDetail.dispatch(assetModel);
    };
    /**
     *
     * @param e
     */
    AssetTableRow.prototype.onToggleExpand = function (e) {
        e.preventDefault();
        this.setState({ expanded: !this.state.expanded });
    };
    /**
     *
     * @return {string}
     */
    AssetTableRow.prototype.getLocationTimeClasses = function () {
        var assetModel = this.props.assetModel;
        var classes = '';
        switch (assetModel.properties.activityStatus) {
            case ActivityStatus.EXPIRED:
                classes = 'fe fe-alert-circle text-warning mr-2';
                break;
            case ActivityStatus.NONE:
                classes = 'fe fe-x-circle text-danger mr-2';
                break;
            case ActivityStatus.RECENT:
                classes = 'fe fe-clock mr-2';
                break;
        }
        return classes;
    };
    AssetTableRow = __decorate([
        observer
    ], AssetTableRow);
    return AssetTableRow;
}(React.Component));
AssetTableRow.contextType = ApplicationContext;
export default injectIntl(AssetTableRow);
